import * as React from 'react';
import { UserService } from "@fnv-core/authentication";
import { Slug } from '@fnv-core/utils';
import { PageHelpers } from './helpers/PageHelpers';
import { PageRenderHelpers , createFormWidget } from './helpers/PageRenderHelpers';
import { PageProps } from './interfaces/PageInterfaces';
import { MenuHelpers } from './helpers/MenuHelpers';
import { MijnFNVPageContext } from './helpers/MijnFNVPageContext';
import { FormService } from "../../services/FormService";
import { AnimationService, ANIMATION_DASHBOARD_LOADING_CONTEXT } from '../../services/AnimationService';
import { CreateFormViewModel } from './helpers/create-form-viewmodel';
import ReactHtmlParser from 'react-html-parser';

export class CTAViewDataPage extends React.Component<PageProps> {
    

    componentDidMount() {    
        AnimationService.enableFormAnimations();
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
    }

    componentDidUpdate() {
        this.handleAnimations();
    }

    handleAnimations() {
        AnimationService.enableAnimations(ANIMATION_DASHBOARD_LOADING_CONTEXT);
        AnimationService.triggerAnimations();
    }

    render() {
        MenuHelpers.showBreadCrumbs();

        if (this.props.kenticoPage.MijnFnvCTAViewPagina.MenuType === "eenvoudig") {
            MenuHelpers.hideMenu();
        } else {
            MenuHelpers.showMenu();
        }

        PageHelpers.setBreadcrumbsPageTitle(this.props.kenticoPage.MijnFnvCTAViewPagina.Titel);

        const pageWidth = this.props.kenticoPage.MijnFnvCTAViewPagina.PageWidth;
        let spaceColumn = "col-md-2";
        let contentColumn = "col-md-8";
        let formTitleColumn = "col-md-8";
        if (pageWidth == "smal") {
            spaceColumn = "col-md-1";
            contentColumn = "col-md-10";
            formTitleColumn = "col-md-10";
        }

        let nameMemberInLidZoekenSubfunction = "";
        let memberState = <></>;
        if (
            this.context &&
            this.context.pathParam &&
            this.context.pathParam !== UserService.getUserId()
        ) {
            const memberDetails = FormService.getLidZoekenSubFunctionsForMember();
            if (memberDetails && memberDetails.memberName) {
                nameMemberInLidZoekenSubfunction = memberDetails.memberName;

                memberState = <span className={"member-state " + (memberDetails.isMember ? "member-state--is-member" : "")}></span>;
                }
        }

        const memberDetails = <>{nameMemberInLidZoekenSubfunction &&
            nameMemberInLidZoekenSubfunction !== "" && (
              <h2 className="content__subtitle content__subtitle-member-name">
                {memberState}{nameMemberInLidZoekenSubfunction}
              </h2>
            )}</>;

        this.handleAnimations();
        if (!this.props.kenticoPage.MijnFnvCTAViewPagina) {
            return <></>;
        }
        const CTAViewPagina = this.props.kenticoPage.MijnFnvCTAViewPagina;
        
        return <React.Fragment>
            <div className="row  mijn-fnv__view-page mijn-fnv__ctaview-page">
                <div className={"col-12 " + spaceColumn} />
                <div className={"mijn-fnv__mainBlock col-12 " + contentColumn}> 
                    <h1 className={"mijn-fnv-" + Slug.fromString(CTAViewPagina.Titel) + "__title"}>{CTAViewPagina.Titel}</h1>
                    {memberDetails}
                    <div className="content__hr"></div>
                    {CTAViewPagina.ContentTitle && <h2>{CTAViewPagina.ContentTitle}</h2>}
                    {CTAViewPagina.Intro && <p className="content__intro">{CTAViewPagina.Intro}</p>}
                    {CTAViewPagina.Content && ReactHtmlParser(CTAViewPagina.Content)}                                    
                </div>
                <div className={"col-12 " + spaceColumn} />
            </div>
            <div className="row mijn-fnv__ctaview-highlighted-top">
                <div className="mijn-fnv__ctaview-triangle-light"></div>
            </div>
            <div className="row mijn-fnv__ctaview-highlighted">
                <div className={"col-12 " + spaceColumn} />
                <div className={"col-12  " + contentColumn}>
                    <div className="row">                                            
                        <div className={"col-12 " + formTitleColumn}>
                            <h2>{CTAViewPagina.CheckDataTitle}</h2>
                        </div>
                        <div className="col-12 col-md-2" />
                    </div>
                    
                    {(this.props.kenticoPage as any).RelatedFormBlockViewModels.map((formBlock, index) => {
                        const FormViewModel = CreateFormViewModel(
                            formBlock.MijnFnvCTAViewFormBlockModel.FormDefinition,
                            formBlock.MijnFnvCTAViewFormBlockModel.FormName, 
                            formBlock.MijnFnvCTAViewFormBlockModel.EditPageLink,
                            CTAViewPagina.Titel,
                            formBlock.MijnFnvCTAViewFormBlockModel.FormConfig
                        );
                        return <div key={"formblock-" + index} className="row">
                            <div className="col-12 mijn-fnv__widget-col-wrapper">
                                {createFormWidget(
                                    FormViewModel,
                                    "widget mijn-fnv__widget",
                                    1,
                                    'view'
                                )}
                            </div>
                        </div>;
                    })}
                </div>
                <div className={"col-12 " + spaceColumn} />
            </div>
            <div className="row mijn-fnv__ctaview-block-top">
                <div className="mijn-fnv__ctaview-triangle-highlighted"></div>
            </div>
            <div className="row mijn-fnv__ctaview-block">
                <div className={"col-12 " + spaceColumn} />
                <div className={"mijn-fnv__mainBlock col-12  " + contentColumn}>
                    {// Get all widgets to be shown in page
                    PageHelpers.getWidgets(this.props.kenticoPage).map((widgetDefinition, index) => {
                        widgetDefinition = { ...widgetDefinition };
                        widgetDefinition.editMode = false;
                        // Get the proper widget based on type, set to edit mode
                        return PageRenderHelpers.renderWidget(
                            widgetDefinition,
                            '',
                            index,
                            'view'
                        );
                    })}
                </div> 
                <div className={"col-12 " + spaceColumn} />
            </div>
        </React.Fragment>;
    }

    static contextType = MijnFNVPageContext;
    context!: React.ContextType<typeof MijnFNVPageContext>;
}